/* eslint-disable no-param-reassign  */
import { createSlice } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';

const initialState = {
  lastStepId: 0,
  isValidCurrentStep: false,
  pastStepsCount: 0,
  surveyPassed: false,
  surveyChanged: false,
  manuallySettedInitialSurveyValues: false,
  selectedMortgageSurveyFlow: 'purchase',
  surveyValues: {
    purpose: 'purchase',
    priceTarget: 250000,
    downPaymentTarget: 50000,
    incomeAnnualPreTax: 60000,
    monthlyDebt: 250,
    cashOutAmount: null,
    mortgageBalance: 40000, // TODO change to null
    mortgageTermYears: null,
    creditScore: null,
    dtiEstimate: null,
    propertyType: 'single_family_home',
    occupancy: 'primary',
    stage: null,
    firstTime: false,
    hadBankrupt: false,
    hadForeclosure: false,
    hadMilitaryService: false,
    state: null,
    city: null,
    locationString: '',
    reasonMessage: 'You requested a mortgage quote, which we will email you shortly. To move forward, click Apply Now.',
  },
};

const mortgageSurveySlice = createSlice({
  name: 'mortgageSurveySlice',
  initialState,
  reducers: {
    changeSurveyFieldValue(state, { payload }) {
      const { field, value } = payload;
      state.surveyValues[field] = value;
    },
    changeLastStepId(state, { payload }) {
      state.lastStepId = payload;
    },
    changeStepValidity(state, { payload }) {
      state.isValidCurrentStep = payload;
    },
    incrementPastStepsCount(state) {
      state.pastStepsCount += 1;
    },
    setInitialSurveyValues(state, { payload }) {
      state.surveyValues = { ...payload };
    },
    discardSurveyValues() {
      return { ...initialState };
    },
    discardSteps(state) {
      state.lastStepId = 0;
      state.pastStepsCount = 0;
    },
    setSurveyPassed(state, { payload }) {
      state.surveyPassed = payload;
    },
    setSurveyChanged(state, { payload }) {
      state.surveyChanged = payload;
    },
    setSelectedMortageSurveyFlow(state, { payload }) {
      const { selectedMortgageSurveyFlow } = payload;
      state.selectedMortgageSurveyFlow = selectedMortgageSurveyFlow;
    },
    setManuallyChangedSurveyValues(state, { payload }) {
      state.manuallySettedInitialSurveyValues = payload;
    },
  },
});

export const { actions } = mortgageSurveySlice;

export default mortgageSurveySlice.reducer;

export const useAppActions = () => {
  const dispatch = useDispatch();

  const changeSurveyFieldValue = attrs => {
    dispatch(actions.changeSurveyFieldValue(attrs));
  };

  const changeCurrentStepValidity = valid => {
    dispatch(actions.changeStepValidity(valid));
  };

  const setManuallyChangedSurveyValues = value => {
    dispatch(actions.setManuallyChangedSurveyValues(value));
  };

  const submitCurrentQuestion = id => {
    dispatch(actions.changeLastStepId(id));
  };

  const incrementPastStepsCount = () => {
    dispatch(actions.incrementPastStepsCount());
  };

  const setInitialSurveyValues = surveyValues => {
    dispatch(actions.setInitialSurveyValues(surveyValues));
  };

  const discardSurveyValues = () => {
    dispatch(actions.discardSurveyValues());
  };

  const discardSteps = () => {
    dispatch(actions.discardSteps());
  };

  const setSurveyPassed = value => {
    dispatch(actions.setSurveyPassed(value));
  };

  const setSurveyChanged = value => {
    dispatch(actions.setSurveyChanged(value));
  };

  const setSelectedMortageSurveyFlow = selectedMortgageSurveyFlow => {
    dispatch(actions.setSelectedMortageSurveyFlow({ selectedMortgageSurveyFlow }));
  };

  return {
    changeSurveyFieldValue,
    setManuallyChangedSurveyValues,
    setSelectedMortageSurveyFlow,
    discardSteps,
    setInitialSurveyValues,
    discardSurveyValues,
    changeCurrentStepValidity,
    incrementPastStepsCount,
    submitCurrentQuestion,
    setSurveyPassed,
    setSurveyChanged,
  };
};
/* eslint-enable no-param-reassign */



// WEBPACK FOOTER //
// ./src/reducers/slices/mortgageSurveySlice.js